import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Spin } from 'antd';

import { AppDispatch, RootState } from '../../store';

import NCRoamPricingPlansComponent from './pricing-plan-selector';
import NCRoamSubscriptionSummaryComponent from './subscription-summary';

import withErrorHandler from '../../hoc/with-error-handler';
import axios from '../../shared/axios';

import * as actions from './store/actions';

import './styles.less';

export type NCRoamSubscriptionComponentProps = {};

const NCRoamSubscriptionComponent = (props: NCRoamSubscriptionComponentProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const { ncRoamAgencySubscription, ncRoamAgencySubscriptionLoading } = useSelector((state: RootState) => state.ncRoamSubs);

  const isInitialized = useRef(false);
  const [dataLoaded, setDataLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (!isInitialized.current) {
      isInitialized.current = true;
      loadData();
    }
  }, []);

  const loadData = () => {
    setDataLoaded(false);

    dispatch(actions.getNCRoamAgencySubscription()).then(() => {
      setDataLoaded(true);
    });
  };

  return ncRoamAgencySubscriptionLoading ? (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '250px',
      }}
    >
      <Spin />
    </div>
  ) : dataLoaded ? (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '25px',
        padding: '25px',
      }}
    >
      <NCRoamSubscriptionSummaryComponent subscriptionInfo={ncRoamAgencySubscription} refresh={loadData} />

      {ncRoamAgencySubscription &&
        (!ncRoamAgencySubscription.hasSubscription ||
          ncRoamAgencySubscription.exceedsPlanSize ||
          (ncRoamAgencySubscription.subscriptionStatus !== 'active' &&
            ncRoamAgencySubscription.subscriptionStatus !== 'trialing')) ? (
        <NCRoamPricingPlansComponent subscriptionInfo={ncRoamAgencySubscription} refresh={loadData} />
      ) : null}
    </div>
  ) : null;
};

export default withErrorHandler(NCRoamSubscriptionComponent, axios);
